import React from 'react';

interface StatsProps {
  stats: {
    totalLicenses: number;
    totalUniqueIds: number;
  } | null;
}

const Stats: React.FC<StatsProps> = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-sm font-medium text-gray-500 mb-2">Total Licenses</h3>
        <p className="text-3xl font-bold text-gray-900">{stats.totalLicenses}</p>
      </div>
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-sm font-medium text-gray-500 mb-2">Total Unique IDs</h3>
        <p className="text-3xl font-bold text-gray-900">{stats.totalUniqueIds}</p>
      </div>
    </div>
  );
};

export default Stats;

